import {lazy} from "react";
import {objMap} from "./tools/CommonJS";
import {icn} from "./tools/UIIcons";

export const defaultPath = "/miscon_overview";

export const routes = {
    "/miscon_overview": {name: "Misconfiguration Overview", Comp: lazy(() => import("./pages/MisconOverview"))},
    "/miscon_overview/category": {name: "Misconfiguration Categories", Comp: lazy(() => import("./pages/MisconCategory"))},
    "/miscon_overview/topic": {name: "Misconfiguration Topic", tName: "$1", Comp: lazy(() => import("./pages/TopicMiscon")), redirect:"/miscon_overview"},
    "/action_log": {name: "Action Center", Comp: lazy(() => import("./pages/ActionLog"))},
    "/action_log/explore_action": {name: "Explore action", tName: "$1", Comp: lazy(() => import("./pages/ActionExplore")), redirect:"/action_log"},

    "/benchmark/CIS/issues": {name: "CIS Security Compliance Standards", Comp: lazy(() => import("./pages/Benchmark"))},
    "/benchmark/CIS/mapping": {name: "CIS Controls Mapped to Other Compliance Systems", Comp: lazy(() => import("./pages/CISMapping"))},
    "/benchmark/CIS/issues/topic": {name: "CIS Topic", tName: "$1", Comp: lazy(() => import("./pages/TopicBenchmark")), redirect: "/benchmark/CIS/issues"},

    "/policy_validation": {name: "Policy Validation", Comp: lazy(() => import("./pages/GpoValidator"))},
    "/policy_validation/gpo": {name: "GPO", tName: "$1", Comp: lazy(() => import("./pages/GpoView"))},
    "/active_directory": {name: "Active Directory & Group Policy Objects", Comp: lazy(() => import("./pages/ActiveDirectory"))},
    "/active_directory/ignore_list": {name: "Active Directory Mute Rules", Comp: lazy(() => import("./pages/ADMuteList"))},

    "/custom_policy/policies": {name: "Manage Policies", Comp: lazy(() => import("./pages/CPolAssignment"))},
    "/custom_policy/policies/edit_policy": {name: "Edit Policy", tName: "$1", Comp: lazy(() => import("./pages/CPolEdit")), redirect: "/custom_policy/policies"},
    "/custom_policy/policy_compliance": {name: "Policy Compliance", Comp: lazy(() => import("./pages/CPolComplianceRules"))},
    "/custom_policy/policy_compliance/device": {name: "Device Compliance", Comp: lazy(() => import("./pages/CPolComplianceDevices"))},

    "/cve_overview": {name: "Vulnerability Assessment Overview", Comp: lazy(() => import("./pages/CVEOverview"))},
    "/cve_overview/topic_cve": {name: "Topic CVE", tName: "$1", Comp: lazy(() => import("./pages/TopicCVE")), redirect: "/cve_overview"},
    "/app_control": {name: "Application Control", Comp: lazy(() => import("./pages/AppControl"))},
    "/app_control/system_and_drivers": {name: "Application Control", Comp: lazy(() => import("./pages/AppControl"))},
    "/app_control/app_topic": {name: "Application", tName: "$1", Comp: lazy(() => import("./pages/TopicAppControl")), redirect: "/app_control"},
    "/exec_summary": {name: "Executive Summary", Comp: lazy(() => import("./pages/ExecutiveSummary"))},
    "/intune": {name: "Microsoft Intune", Comp: lazy(() => import("./pages/Intune"))},

    "/device_groups": {name: "Device Groups", Comp: lazy(() => import("./pages/DeviceGroups"))},
    "/permissions": {name: "Permissions", Comp: lazy(() => import("./pages/RolesPermissions"))},
    "/integrations": {name: "Integrations", Comp: lazy(() => import("./pages/Integrations"))},
    "/license": {name: "License", Comp: lazy(() => import("./app/UseLicense"))},
    "/health": {name: "Health", Comp: lazy(() => import("./pages/Health"))},
    "/devices": {name: "Devices", Comp: lazy(() => import("./pages/Devices"))},
    "/device_info": {name: "Device Information", tName: "$1", Comp: lazy(() => import("./pages/DeviceInfo")), redirect:"/devices"},
};

export const notifTypes = {
    clientLog: {h: "Sensor Logs", sub: "Purged after 14 days.", action: "download"},
    offlineExport: {h: "Exported Data", sub: "Purged after 14 days.", action: "download"},
};

export const menu = [
    {h: "Manage", staticMenu: true, subMenu: [
        {h: "Misconfiguration", k: "/miscon_overview", icon: "eye-outline text-lg"},
        {h: "Security Compliance", icon: "shield", perms: {module: "benchmark"}, subMenu: [
            {h: "Compliance Mapper", k: "/benchmark/CIS/mapping"},
            {h: "CIS Compliance", k: "/benchmark/CIS/issues"}
        ]},
        {h: "Custom CIS Policies", icon: "customisation scale-150", subMenu: [
            {h: "Manage Policies", k: "/custom_policy/policies", perms: {module: "customcis"}},
            {h: "Policy Compliance", k: "/custom_policy/policy_compliance", perms: {module: "customcis"}}
        ]},
        {h: "Microsoft Policies", icon: "windows", subMenu:[
            {h: "GPO Validation", k: "/policy_validation", icon: "lock -ml-0.5 mr-0.5", perms: {module: "gpovalidation"}},
            {h: "AD Assessor", k: "/active_directory", icon: "tree", perms: {module: "adgpo", groupIds: [1002, 1005]}},     // Windows Servers, Windows DC Servers
            {h: "MS Intune", k: "/intune", icon: icn.intune, perms: {module: "intune", envs: ["!onprem", "!demo"]}, n: "Beta"}
        ]},
        {h: "Vulnerability Assessment", k: "/cve_overview", icon: "shield", perms: {module: "vuln_assessment"}},
        {h: "Application Control", k: "/app_control", icon: "control", perms: {module: "app_control"}},
        {h: "Devices", k: "/devices", icon: "devices"},
        {h: "Action Center", k: "/action_log", icon: "calendar-check-o"},
        {h: "Executive Summary", k: "/exec_summary", icon: "briefcase"}
    ].filter(Boolean)
    },
    {h: "Settings", className: "text-base", subMenu: [
        {h: "System Health", icon: "health", k: "/health", notifs: objMap(notifTypes, (k, v) => v.h)},
        {h: "Device Groups", icon: "make-group", k: "/device_groups"},
        {h: "Permissions", icon: "configs", k: "/permissions", perms: {admin: 1}},
        {h: "Integrations", icon: "integrations", k: "/integrations", perms: {admin: 1}},
        {h: "License", icon: "liscense text-sm", k: "/license", perms: {admin: 1}}
            // { h: "VDI Images", icon: "vdi", k: "/vdi_images", perms: {admin: 1}, a: async () => appCtx.setDlg({Elm: (await import("./pages/VdiImages")).default})},
    ]
    }
];

export const helpActions = [
    {h: "Can we help?", icon: "room_service", className: "z-20", subMenu: [
        {h: "Welcome tutorial", icon: "video"},
        {h: "Expand license", icon: "cart"},
        {h: "Missing a feature?", icon: "screw"},
        {h: "Report a bug", icon: "bug"},
        {h: "Send log", icon: "report"}
    ]
    }
];
